import { useCallback, useEffect, useRef } from 'react';
import { useReaderContext } from '../../../features/ContentRendering/components/ReaderContext';
import { TOCNode } from '../../../types';
import { useUserRelatedDocumentContext } from '../../DocumentUserRelatedContext';
import { ChapterNavigationDirection } from './types';
import TextVariant from './TextVariant';
import IconVariant from './IconVariant';

function Button({
  chapter,
  direction,
  variant,
}: Readonly<{
  chapter: TOCNode;
  direction: ChapterNavigationDirection;
  variant: 'icon' | 'text';
}>) {
  const { state } = useReaderContext();
  const { navigateToChapter } = useUserRelatedDocumentContext();
  const isLoadingRef = useRef(false);

  const handleClick = useCallback(() => {
    if (isLoadingRef.current) {
      return;
    }
    isLoadingRef.current = true;
    void navigateToChapter(chapter);
  }, [chapter, navigateToChapter]);

  useEffect(() => {
    if (state === 'ready') {
      isLoadingRef.current = false;
    }
  }, [state]);

  return variant === 'icon' ? (
    <IconVariant
      direction={direction}
      onClick={handleClick}
      loading={isLoadingRef.current}
    />
  ) : (
    <TextVariant
      chapter={chapter}
      direction={direction}
      onClick={handleClick}
      loading={isLoadingRef.current}
    />
  );
}

export default Button;
